export default "__VITE_ASSET__Cc8df5jX__"